import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-common" }
const _hoisted_2 = { class: "title-row mb-24" }
const _hoisted_3 = { class: "desc-row mb-24" }
const _hoisted_4 = { class: "button-row" }

import MvButton from '@/components/common/button/MvButton.vue';
import { INFO_EMAIL } from '@/config/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'NftQtnrModifyModal',
  emits: ['confirm'],
  setup(__props, { emit: __emit }) {

const emits = __emit


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('modal.qtnrModify.title')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('modal.qtnrModify.desc', { email: _unref(INFO_EMAIL) })), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(MvButton, {
        type: "rec-primary",
        text: _ctx.$t('common.confirm'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
      }, null, 8, ["text"])
    ])
  ]))
}
}

})